import { initHostingShowcase } from './hosting-calc.js';
import { initPortfolioFilter } from './filter.js';
import { initContactModal } from './contact-modal.js';
import { initThreeMonolith } from './three-monolith.js';
import { initMonolithCursor } from './monolith-cursor.js';
import { initHoloDeck } from './three-holodeck.js';

document.addEventListener('DOMContentLoaded', () => {
  // 1. Initialize Subsystem Modules
  initHostingShowcase();
  initPortfolioFilter();
  initContactModal();

  // 2. 3D Three.js Scene & 3D Monolith Cursor
  initThreeMonolith('monolithThreeContainer');
  initMonolithCursor();
  initHoloDeck();

  // 3. Interactive Pointer Follower & 3D Tilt Systems
  initInteractivePointer();
  init3DTiltCards();

  // 3. Umbrella Switcher (Monolith Host vs TaT Scripts)
  const umbrellaTabs = document.querySelectorAll('.umbrella-tab-btn');
  const umbrellaPanels = document.querySelectorAll('.umbrella-panel');

  umbrellaTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      umbrellaTabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      const target = tab.getAttribute('data-umbrella-target');
      umbrellaPanels.forEach(panel => {
        if (panel.id === target) {
          panel.style.display = 'block';
          setTimeout(() => {
            panel.style.opacity = '1';
            panel.style.transform = 'translateY(0)';
          }, 30);
        } else {
          panel.style.opacity = '0';
          panel.style.transform = 'translateY(15px)';
          setTimeout(() => {
            panel.style.display = 'none';
          }, 250);
        }
      });
    });
  });

  // 4. Rotating Headline in Hero
  const dynamicWord = document.getElementById('heroDynamicWord');
  const wordList = [
    'Cloud Systems',
    'FiveM Frameworks',
    'Proxmox Infrastructure',
    'Shopify & WooCommerce',
    'Golang & C++ Engineering'
  ];
  if (dynamicWord) {
    let wordIdx = 0;
    setInterval(() => {
      dynamicWord.style.opacity = '0';
      dynamicWord.style.transform = 'translateY(12px)';
      setTimeout(() => {
        wordIdx = (wordIdx + 1) % wordList.length;
        dynamicWord.textContent = wordList[wordIdx];
        dynamicWord.style.opacity = '1';
        dynamicWord.style.transform = 'translateY(0)';
      }, 300);
    }, 3000);
  }

  // 5. Scroll Reveal with IntersectionObserver
  const revealElements = document.querySelectorAll('.reveal-on-scroll');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -30px 0px'
    });

    revealElements.forEach(el => observer.observe(el));
  } else {
    revealElements.forEach(el => el.classList.add('is-revealed'));
  }

  // 6. Mobile Menu Drawer Toggle
  const mobileToggle = document.getElementById('mobileNavToggle');
  const mobileMenu = document.getElementById('mobileNavMenu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
    });

    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
      });
    });
  }
});

/**
 * Dynamic Mouse Spotlight Tracker
 */
function initInteractivePointer() {
  const spotlight = document.createElement('div');
  spotlight.className = 'cursor-spotlight';
  document.body.appendChild(spotlight);

  const parallaxOrbits = document.querySelectorAll('.hero-tech-orbit');

  window.addEventListener('mousemove', (e) => {
    const x = e.clientX;
    const y = e.clientY;

    spotlight.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;

    // Parallax motion on hero floating badges
    if (parallaxOrbits.length > 0) {
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      const deltaX = (x - centerX) / centerX;
      const deltaY = (y - centerY) / centerY;

      parallaxOrbits.forEach((badge, idx) => {
        const factor = (idx + 1) * 7;
        badge.style.transform = `translate(${deltaX * factor}px, ${deltaY * factor}px)`;
      });
    }
  });
}

/**
 * 3D Perspective Tilt on Cards with mouse tracking
 */
function init3DTiltCards() {
  const cards = document.querySelectorAll('.tilt-card');
  cards.forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      // Calculate tilt angles (max +/- 8 deg)
      const rotateX = ((y - centerY) / centerY) * -6;
      const rotateY = ((x - centerX) / centerX) * 6;

      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-4px)`;
    });

    card.addEventListener('mouseleave', () => {
      card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0)';
    });
  });
}
